import {
    AppBar,
    IconButton,
    Toolbar,
    Typography,
    Paper,
    Box,

} from "@material-ui/core";
import MROFullScreenRightDrawer from "components/fullwidth_dialog";
import BackIcon from "@material-ui/icons/KeyboardBackspace";
import React, { useContext, useEffect, useMemo, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import MaterialTable from "material-table";
import tableIcons, { options } from "components/universal/table_attributes";
import { TabSectionBar } from "components/tab_component";
import Divider from "@material-ui/core/Divider";
import Accumulative from "./Accumulative";
import InitialExceptions from "./InitialExceptions";
import moment from "moment";
import GetInfoCard from "components/GetInfoCard";
import { formatDateFunctionWithAmPm } from "lib/utils/common_utils";
import CoreExchange from "./CoreExchange";





const useStyles = makeStyles((theme) => ({
    wrapper: {
        margin: "3%",
    },
    appBar: {
        backgroundColor: "#fff",
        color: "#000000CC",
        boxShadow: "0px 3px 6px #0000001A",
        fontSize: '14px'
    },
    backButton: {
        marginRight: theme.spacing(2),
    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    },
    title: {
        fontSize: '16px',
        color: theme.palette.primary.main
    }, title1: {
        fontSize: '14px',

    },
    detail: {
        backgroundColor: "#fff",
        padding: "1%",
    },
    spacing: {
        paddingTop: '15px', paddingBottom: '10px'
    },

    consolidatedTxt: {
        display: "flex", margin: '-23px 0px 20px 1px'

    },
    text: {
        fontSize: "12px"

    },
    button: {
        background: theme.palette.primary.main,
        width: "36px",
        height: " 36px",
        borderRadius: "5px"
    },
    noteText: {
        color: theme.palette.primary.main,
        paddingLeft: "10px", fontStyle: "italic", fontSize: "15px"
    },
    partCard: {
        borderRadius: "8px",
        padding: "5px 12px",
        "& p": {
            fontSize: "14px",
            padding: "5px",
        },
    },

}));




export default function CreateNewApprovedPosition(props) {

    const classes = useStyles();
    const {
        handleClose,
        jobData,
        estData,
        approvedPositionnData,
        currentSelectedOrder,
        currentPosition,
        getApprovedPosition,
        appPosition,
        currPosition,
        setApprovalData,
        setCurrentData,
        setVarianceData,
        setApprovalInitialData,
        approvalInitialData,
        headerDetails,
        permission
    } = props;

    const [currentTab, setCurrentTab] = useState(0);
    let core_exchange = approvedPositionnData?.approvalType
    const navMenu = [
        core_exchange !== 2 && currentSelectedOrder?.sales_order_core_id === null && {
            label: (
                <div className={classes.indicator}>Initial & Exceptions&nbsp;&nbsp; </div>
            ),
        },
        core_exchange !== 2 && currentSelectedOrder?.sales_order_core_id === null && {
            label: (
                <div className={classes.indicator}>Accumulative&nbsp;&nbsp; </div>
            ),
        },
        currentSelectedOrder?.sales_order_core_id !== null &&
        {
            label: (
                <div className={classes.indicator}>
                    Core Exchange&nbsp;&nbsp;
                </div>
            ),
        },
    ].filter(Boolean);



    useEffect(() => {
        const tat = 0;
        const today = moment().format("DD/MM/YYYY");
        const formattedDate = moment(today, "DD/MM/YYYY HH:mm:ss").add(tat, "days").format("DD/MM/YYYY");

        const getApprovalPayload = (data, isInitial = false) => ({
            position: data?.approval_number,
            tat: data?.tat_days_count,
            etd: formattedDate,
            labour: isInitial ? data?.initial_labour : data?.labour_value || 0,
            parts: isInitial ? data?.initial_parts : data?.parts_value || 0,
            services: isInitial ? data?.initial_services : data?.service_value || 0,
            equipment: isInitial ? data?.initial_equipment : data?.equipment_value || 0,
            aog_fee: isInitial ? data?.initial_aog : data?.aog_fee || 0,
            total: isInitial ? data?.initial_total : data?.total,
            currency: data?.currency_name,
            approvalType: data?.approval_type,
            release_type_id: data?.release_type_id,
            sales_rate: data?.customer_sales_rate,
            standard_id: data?.workshop_standard_price_id,
            inducted_start: data?.inducted_start ?? null,
            tat_remaining: null,
            comment: data?.comment,
        });

        let appData = null;
        let curData = null;

        if (appPosition?.data?.length > 0) {
            appData = appPosition.data[appPosition.data.length - 1];

            setApprovalData((ps) => ({ ...ps, ...getApprovalPayload(appData) }));
            setApprovalInitialData((ps) => ({ ...ps, ...getApprovalPayload(appData, true) }));
        } else {
            const inducted = currentSelectedOrder?.inducted_start
                ? moment(currentSelectedOrder.inducted_start, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                : null;

            setApprovalData((ps) => ({
                ...ps,
                approvalType: null,
                tat: 0,
                etd: formattedDate,
                inducted_start: inducted,
                currency: currentSelectedOrder?.currency,
            }));

            setApprovalInitialData((ps) => ({
                ...ps,
                approvalType: null,
                tat: 0,
                etd: formattedDate,
                inducted_start: inducted,
                currency: currentSelectedOrder?.currency,
            }));

            setCurrentTab(0);
        }

        if (currPosition?.data?.length > 0) {
            curData = currPosition.data[currPosition.data.length - 1];

            const currentTotal = +curData?.est_labour + (+curData?.parts) + (+curData?.services) + (+curData?.equipment) + (+curData?.aog_fee);

            setCurrentData((ps) => ({
                ...ps,
                tat: curData?.tat_days,
                labour: curData?.est_labour || 0,
                parts: curData?.parts || 0,
                services: curData?.services || 0,
                equipment: curData?.equipment || 0,
                aog_fee: curData?.aog_fee || 0,
                total: parseFloat(currentTotal).toFixed(2),
                currency: appData?.currency_name || currentSelectedOrder?.currency,
                t_labour: curData?.labour || 0,
            }));

            if (appData) {
                setVarianceData((ps) => ({
                    ...ps,
                    labour: calculateVariance(curData?.est_labour, appData?.labour_value),
                    parts: calculateVariance(curData?.parts, appData?.parts_value),
                    services: calculateVariance(curData?.services, appData?.service_value),
                    equipment: calculateVariance(curData?.equipment, appData?.equipment_value),
                    aog_fee: calculateVariance(curData?.aog_fee, appData?.aog_fee),
                    total: calculateVariance(currentTotal, appData?.total),
                    currency: appData?.currency_name || currentSelectedOrder?.currency,
                }));
            }
        }
    }, [appPosition, currPosition]);











    const calculateVariance = (current, previous) => {
        const variance = parseFloat((+current || 0) - (+previous || 0)).toFixed(2);
        return isNaN(variance) ? "0.00" : variance;
    };

    useEffect(() => {
        if (currentSelectedOrder?.sales_order_core_id !== null) {
            setCurrentTab(0)
        }
    }, [currentSelectedOrder])

    useEffect(() => {
        if (approvedPositionnData !== undefined) {
            if (approvedPositionnData?.approvalType === null || approvedPositionnData?.approvalType === undefined || approvedPositionnData?.approvalType === 1 || currentSelectedOrder?.sales_order_core_id !== null) {
                setCurrentTab(0)
            } else {
                setCurrentTab(1)
            }
        }
    }, [approvedPositionnData])




    // Get Order Number based on conditions
    const getOrderNumber = () => currentSelectedOrder?.order_number || headerDetails?.order_no || "-";

    // Get Raised Date based on conditions
    const getRaisedDate = () =>
        formatDateFunctionWithAmPm(headerDetails?.raised) || "-";
    // Data map to dynamically render each section
    const dataMap = [
        [
            ["Part #", headerDetails?.part_number],
            ["Serial #", headerDetails?.serial_number],
            ["Description", headerDetails?.description],
            ["Quantity", headerDetails?.quantity],
        ],
        [
            ["Customer", headerDetails?.customer],
            ["Customer Ref", headerDetails["cus-ref"]],
            ["2nd Reference", headerDetails?.secondary_customer_ref],
            ["Core Ex Order #", headerDetails?.sales_order_number],

        ],
        [
            ["Order #", getOrderNumber()],
            ["Raised", getRaisedDate()],
            ["Status / Work", headerDetails?.status_work],
            ["Base", headerDetails?.base_station],
        ],
    ];




    const columns = [
        {
            title: "",
            field: "name",
            width: "20%",
            headerStyle: {
                textAlign: "left",
            },
            cellStyle: {
                width: "20%",
                textAlign: "left",
                paddingLeft: '12px'
            },
        },
        {
            title: "Position",
            field: "position"
        },
        {
            title: "TAT*",
            field: "tat"
        },
        {
            title: "ETD",
            field: "etd"
        },
        {
            title: "Labour**",
            field: "labour",
            render: (rowData) => <div style={{ color: rowData?.name === "Variance" ? parseFloat(rowData?.labour) <= 0 ? "#4FC605" : "#FF0202" : "", fontWeight: rowData?.name === "Variance" ? 600 : "" }}>{rowData?.labour}</div>
        },
        {
            title: "Parts",
            field: "parts",
            render: (rowData) => <div style={{ color: rowData?.name === "Variance" ? parseFloat(rowData?.parts) <= 0 ? "#4FC605" : "#FF0202" : "", fontWeight: rowData?.name === "Variance" ? 600 : "" }}>{rowData?.parts}</div>
        },
        {
            title: "Services",
            field: "services",
            render: (rowData) => <div style={{ color: rowData?.name === "Variance" ? parseFloat(rowData?.services) <= 0 ? "#4FC605" : "#FF0202" : "", fontWeight: rowData?.name === "Variance" ? 600 : "" }}>{rowData?.services}</div>
        },
        {
            title: "Equipment",
            field: "equipment",
            render: (rowData) => <div style={{ color: rowData?.name === "Variance" ? parseFloat(rowData?.equipment) <= 0 ? "#4FC605" : "#FF0202" : "", fontWeight: rowData?.name === "Variance" ? 600 : "" }}>{rowData?.equipment}</div>
        },
        {
            title: "Other",
            field: "aog_fee",
            render: (rowData) => <div style={{ color: rowData?.name === "Variance" ? parseFloat(rowData?.aog_fee) <= 0 ? "#4FC605" : "#FF0202" : "", fontWeight: rowData?.name === "Variance" ? 600 : "" }}>{rowData?.aog_fee}</div>
        },
        {
            title: "Total",
            field: "total",
            render: (rowData) => <div style={{ color: rowData?.name === "Variance" ? parseFloat(rowData?.total) <= 0 ? "#4FC605" : "#FF0202" : "", fontWeight: rowData?.name === "Variance" ? 600 : "" }}>{rowData?.total}</div>
        }, {
            title: "Currency",
            field: "currency"
        },




    ]

    const tableOptions = {
        ...options,
        paging: false,
        search: false,
        paging: false,
        rowStyle: { height: 42 },
    };


    const commonProps = {
        handleClose,
        estData,
        currentSelectedOrder,
        currentPosition,
        getApprovedPosition,
    };






    return (
        <div>
            <MROFullScreenRightDrawer open={true}>

                <AppBar position="static" className={classes.appBar} elevation={0}>
                    <Toolbar>
                        <IconButton
                            onClick={handleClose}
                            edge="start"
                            className={classes.backButton}
                            color="inherit"
                            aria-label="back"
                        >
                            <BackIcon />
                        </IconButton>
                        <Typography variant="subtitle2" style={{ fontSize: "17px" }}>
                            Create New Approved Position
                        </Typography>
                    </Toolbar>
                </AppBar>

                <div className={classes.wrapper}>
                    <Typography className={classes.title}>Order Overview</Typography>

                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor="#F5F5F5"
                        className={classes.partCard}
                    >
                        {dataMap.map((section, index) => (
                            <Box flexGrow={1} key={index}>
                                <div style={{ width: "100%" }}>
                                    {section.map(([key, value]) => (
                                        <GetInfoCard keyName={key} value={value || "-"} key={key} />
                                    ))}
                                </div>
                            </Box>
                        ))}
                    </Box>








                    <div className={classes.spacing}>
                        <MaterialTable
                            style={{
                                boxShadow: "0px 1px 4px #00000033",
                            }}
                            // isLoading={loadingCurrentPosition}
                            icons={tableIcons}
                            title={""}
                            columns={columns}
                            data={jobData || []}
                            options={tableOptions}
                            components={{
                                Toolbar: () => null,
                            }}
                            localization={{
                                toolbar: {},
                                body: {
                                    emptyDataSourceMessage: "No data found",
                                    filterRow: {
                                        filterTooltip: "Filter",
                                    },
                                },
                            }}

                        />
                    </div>




                    <div>
                        <i>* Current Position TAT is a live value from receipt / start of job to today.</i>
                    </div>
                    <div className={classes.spacing}>
                        <i>** Labour figure shown in the table is calculated from the estimated hours from each action. The ACTUAL bookings currently equate to:  <span className={classes.noteText}>{currentPosition?.t_labour}  </span></i>
                    </div>
                    <Typography className={classes.title}>New Approval</Typography>
                    <div className={classes.spacing}>
                        Select the type of Approval you want to create
                    </div>
                    <Paper style={{ marginTop: '10px' }}>
                        <TabSectionBar
                            // completed={completed}
                            {...props}
                            tabProperties={navMenu}
                            currentTab={currentTab}
                            setCurrentTab={setCurrentTab}
                            isGettingDetails={false}
                        />
                        <Divider
                            variant="fullWidth"
                            style={{ padding: "1px", backgroundColor: "rgba(222, 214, 214, 0.2)" }}
                        />

                        {core_exchange !== 2 && currentTab === 1 && (
                            <Accumulative
                                {...commonProps}
                                approvedPositionnData={approvedPositionnData}
                            />
                        )}

                        {currentTab === 0 && (
                            currentSelectedOrder?.sales_order_core_id !== null ? (
                                <CoreExchange
                                    {...commonProps}
                                    approvedPositionnData={approvalInitialData}
                                    aog_fee_highest={approvedPositionnData?.aog_fee}
                                    permission={permission}
                                />
                            ) : <InitialExceptions
                                {...commonProps}
                                approvedPositionnData={approvalInitialData}
                                aog_fee_highest={approvedPositionnData?.aog_fee}
                            />
                        )}


                    </Paper>
                </div>



            </MROFullScreenRightDrawer >




        </div >
    )
}
